import React from "react"
import styled from "styled-components"
import {FacebookIcon, InstagramIcon, YoutubeIcon } from "../Icons"

const SocialIcon = styled.ul`
  display: flex;
  flex-wrap:wrap;
  margin:0 -10px;
  padding: 0;
`
const SocialItem = styled.li`
  list-style: none;    
  padding:0 10px;
  margin-bottom:0;
  a{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    svg{
      fill:#fff;
    }
    &:hover{
      svg{
        fill:#E9242A;
      }
    }
  }
`
const SocialNetwork = () => {
  return(	
    <SocialIcon>
    <SocialItem><a className="item-link facebook" href="https://www.facebook.com/engineeredmetalbuildings" target="_blank" rel="noreferrer" aria-label="Facebook"><FacebookIcon /></a></SocialItem>
    <SocialItem><a className="item-link instagram" href=" https://www.instagram.com/engineeredmetalbuildings" target="_blank" rel="noreferrer" aria-label="instagram"><InstagramIcon /></a></SocialItem>
    <SocialItem><a className="item-link youtube" href=" https://youtube.com/@EngineeredMetalBuildings" target="_blank" rel="noreferrer" aria-label="youtube"><YoutubeIcon /></a></SocialItem>
  </SocialIcon> 			
	)
}
export default SocialNetwork